var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.49 1.977a2 2 0 0 1 2.872 0l4.448 4.59a2 2 0 0 0 1.984.532l6.147-1.752a2 2 0 0 1 2.488 1.437l1.556 6.199a2 2 0 0 0 1.453 1.452l6.199 1.557a2 2 0 0 1 1.436 2.488l-1.751 6.146a2 2 0 0 0 .532 1.985l4.59 4.447a2 2 0 0 1 0 2.873l-4.59 4.447a2 2 0 0 0-.532 1.985l1.751 6.146a2 2 0 0 1-1.436 2.488l-6.199 1.557a2 2 0 0 0-1.453 1.452l-1.556 6.2a2 2 0 0 1-2.488 1.436l-6.147-1.752a2 2 0 0 0-1.984.532l-4.448 4.59a2 2 0 0 1-2.872 0l-4.448-4.59a2 2 0 0 0-1.984-.532l-6.147 1.752a2 2 0 0 1-2.488-1.437l-1.556-6.199a2 2 0 0 0-1.453-1.452l-6.199-1.557A2 2 0 0 1 5.78 46.51l1.751-6.146A2 2 0 0 0 7 38.378l-4.59-4.447a2 2 0 0 1 0-2.873L7 26.611a2 2 0 0 0 .531-1.985L5.78 18.48a2 2 0 0 1 1.436-2.488l6.2-1.557a2 2 0 0 0 1.452-1.453l1.556-6.198a2 2 0 0 1 2.488-1.437L25.058 7.1a2 2 0 0 0 1.984-.532l4.448-4.59Z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEFF4",
    d: "M26.792 40.732 22.517 26.01c-.443-1.527.475-3.243 2.051-3.834a2.977 2.977 0 0 1 1.873-.09l14.722 4.275c1.527.443 2.285 2.08 1.694 3.656-.166.443-.43.85-.77 1.191l-4.78.722 4.557 4.558c1.397 1.397 1.422 3.636.057 5.001-1.366 1.366-3.605 1.34-5.002-.056l-4.558-4.558-.722 4.781c-1.211 1.212-3.086 1.3-4.187.2a2.613 2.613 0 0 1-.66-1.124Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.921 41.49c1.366-1.366 1.34-3.605-.056-5.002l-4.558-4.558 4.78-.722a3.33 3.33 0 0 0 .77-1.191c.592-1.576-.167-3.213-1.693-3.656L26.44 22.087a2.976 2.976 0 0 0-1.872.089c-.459.172-.862.44-1.192.77L41.92 41.489Z",
    opacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.084772b586904f5bb27fe5dd0f8bd973.svg";
export { ForwardRef as ReactComponent };